import {requests} from "../../helpers/api.services";
import {SPEAKER_SETTINGS_URL} from "../../helpers/api.routes";

export const AdminSpeakerSettingsService = {
    get: () => requests.get(SPEAKER_SETTINGS_URL),
    create: (params: any) => requests.post(SPEAKER_SETTINGS_URL, params)
}